import React from 'react';
import Loadable from 'react-loadable';
import { RouteComponentProps } from 'react-router';

import BlankLoadingPage from '../../../shared/components/BlankLoadingPage';
import { getQueryFromLocation } from '../../../shared/utils/urls';
import { LoadableWidgetCancelAppointmentPage } from '../../index';

const LoadableSchedulingCancellationPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "schedulingCancellationPage" */ './SchedulingCancellationPage'),
  loading: () => <BlankLoadingPage />,
});

type Params = { id: string };

export default function SchedulingCancellationPage(props: RouteComponentProps<Params>) {
  const { exp_widget_v2 } = getQueryFromLocation(props.location);

  if (exp_widget_v2 == null || exp_widget_v2 === '') {
    return <LoadableWidgetCancelAppointmentPage {...props} />;
  }
  return <LoadableSchedulingCancellationPage {...props} />;
}
